import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import isElectron from 'is-electron';
import { fetchSocialIntegrationSettings } from 'flow/actions/social-integration-actions';
import { selectSocialIntegrationSettings } from 'flow/selectors/social-integration-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

const SocialIntegrationCallback = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const history = useHistory();

    const { extensionKey, syncSource } = useParams<{
        extensionKey: ExtensionKey;
        syncSource: string;
    }>();

    const socialIntegrationSettings = useAppSelector(
        selectSocialIntegrationSettings,
    );

    useEffect(() => {
        dispatch(fetchSocialIntegrationSettings());
    }, []);

    useEffect(() => {
        handleCallBack();
    }, [socialIntegrationSettings]);

    const handleCallBack = () => {
        if (!socialIntegrationSettings) {
            return;
        }

        if (isElectron()) {
            if (syncSource in socialIntegrationSettings) {
                history.push(
                    generatePath(
                        routes[
                            'settings.account.socialintegration.integration'
                        ],
                        { extensionKey, syncSource },
                    ),
                );
            } else {
                history.push(
                    generatePath(routes['settings.account'], { extensionKey }),
                );
            }
        } else {
            if (!window.opener) {
                window.close();
            } else if (syncSource in socialIntegrationSettings) {
                window.opener.postMessage(
                    {
                        direction: 'social-integration-callback',
                        message: 'done',
                    },
                    '*',
                );
                window.close();
            } else {
                window.opener.postMessage(
                    {
                        direction: 'social-integration-callback',
                        message: 'fail',
                    },
                    '*',
                );
                window.close();
            }
        }
    };

    return null;
};

export default SocialIntegrationCallback;
